var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"basic-avatar",style:({ width: _vm.size + 'px', height: _vm.size + 'px' })},[_c('img',{attrs:{"src":_vm.src || _vm.defaultAvatar}})])
}
var staticRenderFns = []

export { render, staticRenderFns }